import { TreeDataNode } from "antd";

export const dataTypeTreeDataForDebtInstruments: TreeDataNode[] = [
  {
    title: "Commercial Paper",
    key: "Commercial Paper",
    children: [
      {
        title: "Facility Size",
        key: "Commercial Paper_Facility Size",
        children: [
          { title: "Series 1", key: "Commercial Paper_Facility Size_Series 1", isLeaf: true },
          { title: "Series 2", key: "Commercial Paper_Facility Size_Series 2", isLeaf: true },
          { title: "Series 3", key: "Commercial Paper_Facility Size_Series 3", isLeaf: true },
        ],
      },
      {
        title: "Principal Value",
        key: "Commercial Paper_Principal Value",
        children: [
          { title: "Series 1", key: "Commercial Paper_Principal Value_Series 1", isLeaf: true },
          { title: "Series 2", key: "Commercial Paper_Principal Value_Series 2", isLeaf: true },
          { title: "Series 3", key: "Commercial Paper_Principal Value_Series 3", isLeaf: true },
        ],
      },
      {
        title: "Accrued Interest",
        key: "Commercial Paper_Accrued Interest",
        children: [
          { title: "Series 1", key: "Commercial Paper_Accrued Interest_Series 1", isLeaf: true },
          { title: "Series 2", key: "Commercial Paper_Accrued Interest_Series 2", isLeaf: true },
          { title: "Series 3", key: "Commercial Paper_Accrued Interest_Series 3", isLeaf: true },
        ],
      },
    ],
  },

  {
    title: "Revolving Credit Facilities",
    key: "Revolving Credit Facilities",
    children: [
      {
        title: "Maturity Date",
        key: "Revolving Credit Facilities_Maturity Date",
        children: [
          { title: "Facility 1", key: "Revolving Credit Facilities_Maturity Date_Facility 1", isLeaf: true },
          { title: "Facility 2", key: "Revolving Credit Facilities_Maturity Date_Facility 2", isLeaf: true },
          { title: "Facility 3", key: "Revolving Credit Facilities_Maturity Date_Facility 3", isLeaf: true },
        ],
      },
      {
        title: "Size of Facility",
        key: "Revolving Credit Facilities_Size of Facility",
        children: [
          { title: "Facility 1", key: "Revolving Credit Facilities_Size of Facility_Facility 1", isLeaf: true },
          { title: "Facility 2", key: "Revolving Credit Facilities_Size of Facility_Facility 2", isLeaf: true },
          { title: "Facility 3", key: "Revolving Credit Facilities_Size of Facility_Facility 3", isLeaf: true },
        ],
      },
      {
        title: "Current Drawdown",
        key: "Revolving Credit Facilities_Current Drawdown",
        children: [
          { title: "Facility 1", key: "Revolving Credit Facilities_Current Drawdown_Facility 1", isLeaf: true },
          { title: "Facility 2", key: "Revolving Credit Facilities_Current Drawdown_Facility 2", isLeaf: true },
          { title: "Facility 3", key: "Revolving Credit Facilities_Current Drawdown_Facility 3", isLeaf: true },
        ],
      },
      {
        title: "Accrued Interest",
        key: "Revolving Credit Facilities_Accrued Interest",
        children: [
          { title: "Facility 1", key: "Revolving Credit Facilities_Accrued Interest_Facility 1", isLeaf: true },
          { title: "Facility 2", key: "Revolving Credit Facilities_Accrued Interest_Facility 2", isLeaf: true },
          { title: "Facility 3", key: "Revolving Credit Facilities_Accrued Interest_Facility 3", isLeaf: true },
        ],
      },
    ],
  },

  {
    title: "Term Loans",
    key: "Term Loans",
    children: [
      {
        title: "Maturity Date",
        key: "Term Loans_Maturity Date",
        children: Array.from({ length: 10 }, (_, i) => ({
          title: `Facility ${i + 1}`,
          key: `Term Loans_Maturity Date_Facility ${i + 1}`,
          isLeaf: true,
        })),
      },
      {
        title: "Principal Value",
        key: "Term Loans_Principal Value",
        children: Array.from({ length: 10 }, (_, i) => ({
          title: `Facility ${i + 1}`,
          key: `Term Loans_Principal Value_Facility ${i + 1}`,
          isLeaf: true,
        })),
      },
      {
        title: "Accrued Interest",
        key: "Term Loans_Accrued Interest",
        children: Array.from({ length: 10 }, (_, i) => ({
          title: `Facility ${i + 1}`,
          key: `Term Loans_Accrued Interest_Facility ${i + 1}`,
          isLeaf: true,
        })),
      },
      {
        title: "Change of Control Premium",
        key: "Term Loans_Change of Control Premium",
        children: Array.from({ length: 10 }, (_, i) => ({
          title: `Facility ${i + 1}`,
          key: `Term Loans_Change of Control Premium_Facility ${i + 1}`,
          isLeaf: true,
        })),
      },
    ],
  },

  {
    title: "Bonds and Notes",
    key: "Bonds and Notes",
    children: [
      {
        title: "Maturity Date",
        key: "Bonds and Notes_Maturity Date",
        children: Array.from({ length: 40 }, (_, i) => ({
          title: `Series ${i + 1}`,
          key: `Bonds and Notes_Maturity Date_Series ${i + 1}`,
          isLeaf: true,
        })),
      },
      {
        title: "Principal Value",
        key: "Bonds and Notes_Principal Value",
        children: Array.from({ length: 40 }, (_, i) => ({
          title: `Series ${i + 1}`,
          key: `Bonds and Notes_Principal Value_Series ${i + 1}`,
          isLeaf: true,
        })),
      },
      {
        title: "Accrued Interest",
        key: "Bonds and Notes_Accrued Interest",
        children: Array.from({ length: 40 }, (_, i) => ({
          title: `Series ${i + 1}`,
          key: `Bonds and Notes_Accrued Interest_Series ${i + 1}`,
          isLeaf: true,
        })),
      },
      {
        title: "Change of Control Premium",
        key: "Bonds and Notes_Change of Control Premium",
        children: Array.from({ length: 40 }, (_, i) => ({
          title: `Series ${i + 1}`,
          key: `Bonds and Notes_Change of Control Premium_Series ${i + 1}`,
          isLeaf: true,
        })),
      },
    ],
  },
];
